(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	/* The following defined the Routes related Login, Registration etc. */
	ngModule.config(function($stateProvider, $urlRouterProvider) {
		$stateProvider
        .state('publicStoreDesignReview', {
            needsAuth: false,
            url: '/storefront/:id/design-review',
            params: {
                id: null
            },
            views: {
                content: {
                    templateUrl: 'states/public/storefront/design_review/template.html',
                    controller: 'SingleStoreCtrl'
                },
                nav: {
                    templateUrl: 'templates/nav.html',
                    controller: 'SingleStoreNavController'
                }
            },
            resolve: {
                storeId: function($stateParams) {
                    return $stateParams.id;
                },
                // do we need this? seems redundant
                // TODO: review this, check SingleStoreNavController
                store: function($stateParams, $Stores){

                    return $Stores.getStoreWithPromise($stateParams.id).then((store) => {

                        // console.log('singleStore -> resolve -> store', store);
                        return store;
                    });
                }
                // store: function($stateParams) {
                //     return $Stores.get($stateParams.id);
                // }
            }
        })

	});

})();
